// import React from 'react';
// import { makeStyles } from '@material-ui/core/styles';
// import Popover from '@material-ui/core/Popover';
// import Typography from '@material-ui/core/Typography';
// import Button from '@material-ui/core/Button';
// import DropDownAvatar from './DropDownAvatar';
// import DropDownOptions from './DropDownOptions';
// const useStyles = makeStyles(theme => ({
//     typography: {
//         padding: theme.spacing(2),
//     },
// }));

// export default function AvatarPopover() {
//     const classes = useStyles();
//     const [anchorEl, setAnchorEl] = React.useState(null);

//     const handleClick = event => {
//         setAnchorEl(event.currentTarget);
//     };

//     const handleClose = () => {
//         setAnchorEl(null);
//     };

//     const open = Boolean(anchorEl);
//     const id = open ? 'simple-popover' : undefined;

//     return (
//         <div>
//             <DropDownAvatar onClick={handleClick} />
//             <Popover
//                 id={id}
//                 open={open}
//                 anchorEl={anchorEl}
//                 onClose={handleClose}
//                 anchorOrigin={{
//                     vertical: 'bottom',
//                     horizontal: 'right',
//                 }}
//                 transformOrigin={{
//                     vertical: 'top',
//                     horizontal: 'right',
//                 }}
//             >
//                 <DropDownOptions hide={handleClose}/>
//             </Popover>
//         </div>
//     );
// }

import React from 'react';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import { Spin, Popover } from 'antd';
import MenuItem from '@material-ui/core/MenuItem';
import DropDownAvatar from './DropDownAvatar';
import DropDownOptions from './DropDownOptions';
import '../styles/avatarDropdown.scss'

export default function AvatarPopover() {
    const [anchorEl, setAnchorEl] = React.useState(false);

    const handleClick = event => {

        // setAnchorEl(event.currentTarget);
        setAnchorEl(!anchorEl)
    };

    const handleClose = () => {
        setAnchorEl(false);
    };
    const content = () => <DropDownOptions hide={handleClose} />

    return (
        <div>
            {/* <DropDownAvatar aria-controls="simple-menu" aria-haspopup="true" onClick={e => handleClick(e)} /> */}
            <Popover placement="bottomRight" content={<DropDownOptions hide={handleClose} />} trigger="click"
                visible={anchorEl}
                onVisibleChange={() => setAnchorEl(!anchorEl)}
            >

                <DropDownAvatar aria-controls="simple-menu" aria-haspopup="true" onClick={e => handleClick(e)} />

            </Popover>
            {/* <Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
        Open Menu
      </Button> */}
            {/* <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                className="dropdown"
            >
                <DropDownOptions hide={handleClose} />
            </Menu> */}
        </div>
    );
}
